module.exports = {
  default: {
    title: "Default",
    menus: [],
  },
  adminMenu: {
    title: "ADMIN",
    menus: [
      {
        id: 0,
        name: "Dashboard",
        icon: "structure",
        parent: "",
        path: "/admin-dashboard",
      },
      // {
      //   id: 1,
      //   name: "New Company Request",
      //   path: "/company-request-list",
      //   icon: "newcompany",
      //   parent: "",
      // },
      {
        id: 2,
        name: "Area Management",
        icon: "areamanage",
        parent: "",
        path: "",
        child: true,
      },
      {
        id: 83,
        name: "Built-Up Space Category",
        icon: "areamanage",
        parent: 2,
        path: "/area-types",
      },
      {
        id: 84,
        name: "Building & Floor Details",
        icon: "areamanage",
        parent: 2,
        path: "/rent-area",
      },

      {
        id: 85,
        name: "Built-Up Space Allocation Details",
        icon: "areamanage",
        parent: 2,
        path: "/space-allocation-details",
      },
      {
        id: 86,
        name: "Land Allocation Details",
        icon: "areamanage",
        parent: 2,
        path: "/land-allocation-details",
      },
      {
        id: 80,
        name: "Built-Up Space/Land in KSPACE Premises",
        icon: "areamanage",
        parent: 2,
        path: "/builtup-space",
      },
      // {
      //   id: 81,
      //   name: "Equipped Facility",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/equip-facility",
      // },
      // {
      //   id: 82,
      //   name: "Land On Lease",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/land-lease",
      // },
      // {
      //   id: 83,
      //   name: "Joint Venture",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/joint-venture",
      // },
      // {
      //   id: 84,
      //   name: "Own Land",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/own-land",
      // },
      {
        id: 3,
        name: "Homepage Management",
        parent: "",
        child: true,
        icon: "house",
      },
      {
        id: 4,
        icon: "slide",
        path: "/banner-list",
        name: "Banner Images",
        parent: 3,
      },
      {
        id: 5,
        path: "/scrolling-list",
        icon: "bell",
        name: "Scrolling Notification",
        parent: 3,
      },
      {
        id: 6,
        path: "/scope-activity-list",
        icon: "activity",
        name: "Scope of Activities",
        parent: 3,
      },
      {
        id: 51,
        path: "/maintext-list",
        icon: "maintext",
        name: "Main-Text",
        parent: 7,
      },
      {
        id: 52,
        path: "/organization-list",
        icon: "structure",
        name: "Organizational Structure",
        parent: 7,
      },
      {
        id: 8,
        path: "/quotes-list",
        icon: "quote",
        name: "Messages",
        parent: 3,
      },
      {
        id: 9,
        path: "/accomplishment-list",
        icon: "flag",
        name: "Our Accomplishments",
        parent: 3,
      },
      {
        id: 10,
        path: "/advertisement-list",
        icon: "flag",
        name: "Advertisements",
        parent: 3,
      },

      {
        id: 7,
        name: "About KSPACE",
        parent: 3,
        icon: "about",
        child: true,
      },
      {
        id: 10,
        name: "Master Table",
        parent: "",
        icon: "book",
        child: true,
      },
      {
        id: 101,
        path: "/domain-list",
        icon: "technology",
        name: "Domains",
        parent: 10,
      },
      {
        id: 102,
        path: "/qualifications-list",
        icon: "academic",
        name: "Qualifications",
        parent: 10,
      },
      {
        id: 103,
        path: "/tenderCategory-list",
        icon: "companylist",
        name: "Tender - Category",
        parent: 10,
      },
      {
        id: 104,
        path: "/tenderOrganization-list",
        icon: "company",
        name: "Tender - Organizations",
        parent: 10,
      },
      {
        id: 105,
        path: "/techo-transfer-category-list",
        icon: "companylist",
        name: "Technology - Category",
        parent: 10,
      },
      {
        id: 106,
        path: "/techo-transfer-organization-list",
        icon: "company",
        name: "Technology - Organizations",
        parent: 10,
      },

      {
        id: 11,
        name: "Companies",
        parent: "",
        icon: "company",
        child: true,
      },
      // {
      //   id: 13,
      //   path: "/newrequest-application-kspace",
      //   icon: "application",
      //   name: "New Applications",
      //   parent: 12,
      // },
      // {
      //   id: 14,
      //   path: "/companies-in-kspace",
      //   icon: "intitutions",
      //   name: "Institutions",
      //   parent: 12,
      // },
      {
        id: 21,
        name: "KSPACE premises",
        icon: "companylist",
        path: "/company-request-list/kspace",
        parent: 11,
        // child: true,
      },
      {
        id: 21,
        name: "KSPACE - Own Premises",
        icon: "companylist",
        path: "/company-request-list/own",
        parent: 11,
        // child: true,
      },
      {
        id: 15,
        name: "Existing companies affiliated with KSPACE",
        path: "/kerala-companies-list",
        icon: "companylist",
        parent: 11,
        // child: true,
      },
      // {
      //   id: 12,
      //   name: "KSPACE",
      //   icon: "companylist",
      //   parent: 11,
      //   child: true,
      // },

      // {
      //   id: 17,
      //   path: "/kerala-companies-list",
      //   icon: "intitutions",
      //   name: "Institutions",
      //   parent: 15,
      // },
      // {
      //   id: 131,
      //   path: "/newrequest-application-kerala",
      //   icon: "application",
      //   name: "New Applications",
      //   parent: 15,
      // },

      {
        id: 21,
        name: "International Companies",
        icon: "companylist",
        path: "/international-companies-list",
        parent: 11,
        // child: true,
      },
      // {
      //   id: 211,
      //   path: "/newrequest-application-international",
      //   icon: "application",
      //   name: "New Applications",
      //   parent: 21,
      // },
      {
        id: 18,
        name: "Indian Companies",
        icon: "companylist",
        path: "/india-companies-list",
        parent: 11,
        // child: true,
      },

      // {
      //   id: 22,
      //   path: "/international-companies-list",
      //   icon: "intitutions",
      //   name: "Institutions",
      //   parent: 21,
      // },
      // {
      //   id: 20,
      //   path: "/india-companies-list",
      //   icon: "intitutions",
      //   name: "Institutions",
      //   parent: 18,
      // },
      // {
      //   id: 201,
      //   path: "/newrequest-application-india",
      //   icon: "application",
      //   name: "New Applications",
      //   parent: 18,
      // },
      {
        id: 23,
        path: "/resource-list",
        name: "Resource Personnel",
        icon: "resource",
        parent: "",
      },

      {
        id: 26,
        path: "/manpower-list",
        name: "Expert Manpower Registry",
        parent: "",
        icon: "expert",
      },
      {
        id: 27,
        // path: "/candidates-list",
        name: "Job Seeker",
        parent: "",
        child: true,
        icon: "directory",
      },
      {
        id: 271,
        path: "/candidates-list/registry",
        name: "Job Seeker Registry",
        parent: 27,
        icon: "directory",
      },
      {
        id: 272,
        path: "/candidates-list/employed",
        name: "Directory of Job Seekers Employed through KSPACE",
        parent: 27,
        icon: "directory",
      },
      {
        id: 273,
        path: "/candidates-list/inactive",
        name: "Directory of Inactive Job Seeker Registrations",
        parent: 27,
        icon: "directory",
      },
      {
        id: 274,
        path: "/candidates-list/optedout",
        name: "Directory of Job Seekers Opted-Out",
        parent: 27,
        icon: "directory",
      },
      {
        id: 28,
        path: "/profiles-list",
        name: "Downloaded Profiles",
        parent: "",
        icon: "resource",
      },
      {
        id: 64,
        path: "/policies-list",
        name: "Policies & Regulations",
        parent: "",
        icon: "application",
      },
      {
        id: 65,
        path: "/incentives-list",
        name: "Financial Support and Incentives",
        parent: "",
        icon: "resource",
      },
      {
        id: 66,
        path: "/news-list",
        name: "News and Updates",
        parent: "",
        icon: "application",
      },
      {
        id: 67,
        path: "/market-analysis",
        name: "Market Analysis",
        parent: "",
        icon: "market",
      },
      {
        id: 68,
        path: "/challenges",
        name: "Challenges",
        parent: "",
        icon: "ideas",
      },


      {
        id: 29,
        name: "Market Research",
        icon: "market",
        parent: "",
        child: true,
      },
      {
        id: 30,
        path: "/tender-list",
        icon: "application",
        name: "Tender",
        parent: 29,
      },
      {
        id: 40,
        path: "/trade-list",
        icon: "application",
        name: "Trade Enquiries",
        parent: 29,
      },

      {
        id: 31,
        path: "/publication-list",
        icon: "activity",
        name: "Publications",
        parent: 29,
      },
      {
        id: 32,
        name: "New Business Ideas",
        icon: "ideas",
        parent: "",
        child: true,
      },
      {
        id: 33,
        path: "/project-proposal-list",
        icon: "proposals",
        name: "Project Proposals",
        parent: 32,
      },
      {
        id: 34,
        path: "/transfer-proposal-list",
        icon: "technology",
        name: "Technology Transfer Proposals",
        parent: 32,
      },
      // {
      //   id: 35,
      //   path: "/professionalbodies-list",
      //   name: "Professional Bodies",
      //   icon: "house",
      //   parent: "",
      // },

      {
        id: 38,
        name: "Academic Institutions",
        icon: "academic",
        parent: "",
        child: true,
      },
      {
        id: 39,
        path: "/academicinstitution-list",
        icon: "application",
        name: "Applications",
        parent: 38,
      },

      // {
      //   id: 42,
      //   path: "/institutionproposal-list",
      //   icon: "directory",
      //   name: "Student Proposal",
      //   parent: 38,
      // },

      // {
      //   id: 44,
      //   path: "/intershiptraining-list",
      //   icon: "directory",
      //   name: "Internship/Training",
      //   parent: 38,
      // },

      {
        id: 45,
        icon: "advisors",
        path: "/advisors-list",
        name: "Spacepark Advisors",
        parent: "",
      },

      {
        id: 87,
        name: "Internship",
        icon: "company",
        parent: "",
        child: true,
      },
      {
        id: 88,
        path: "/admin-internship-requests",
        icon: "news",
        name: "Requests",
        parent: 87,
      },
      {
        id: 89,
        path: "/admin-internship-applications",
        icon: "application",
        name: "Applications",
        parent: 87,
      },
      {
        id: 91,
        path: "/admin-internships-doing",
        icon: "activity",
        name: "Directory of Internships Doing",
        parent: 87,
      },
      {
        id: 92,
        path: "/admin-internships-completed",
        icon: "book",
        name: "Directory of Internships Completed",
        parent: 87,
      },
      {
        id: 93,
        path: "/admin-internships-absorbed",
        icon: "resource",
        name: "Directory of Internships Absorbed",
        parent: 87,
      },
      {
        id: 46,
        name: "Events",
        icon: "events",
        parent: "",
        child: true,
      },
      {
        id: 47,
        icon: "eventlist",
        name: "Kspace Event List",
        path: "/event-list-kspace",
        parent: 46,
      },
      {
        id: 47,
        icon: "eventlist",
        name: "Other Event List",
        path: "/event-list-others",
        parent: 46,
      },
      {
        id: 48,
        icon: "book",
        name: "Registration",
        name: "Registration",
        path: "/event-booking",
        parent: 46,
      },
      //       {
      //   id: 58,
      //   icon: "book",
      //   name: "Payment Details",
      //   path: "/payment-details",
      //   parent: 46,
      // },

      {
        id: 49,
        icon: "slide",
        name: "Gallery",
        path: "",
        child: true,
        parent: "",
      },
      {
        id: 50,
        icon: "advisors",
        path: "/admin-mou",
        name: "MOU",
        parent: "",
      },
      {
        id: 65,
        icon: "advisors",
        path: "/membership",
        name: "Memberships",
        parent: "",
      },
      {
        id: 70,
        icon: "advisors",
        path: "/faq-list",
        name: "FAQ",
        parent: "",
      },
      {
        id: 66,
        icon: "advisors",
        path: "/vendors-list",
        name: "Vendors",
        parent: "",
      },
      {
        id: 90,
        icon: "mail",
        path: "/bulk-emails",
        name: "Bulk Email",
        parent: "",
      },
      {
        id: 61,
        icon: "slide",
        name: "Images",
        path: "/images",
        parent: 49,
      },
      {
        id: 62,
        icon: "slide",
        name: "Videos",
        path: "/videos",
        parent: 49,
      },
      {
        id: 63,
        path: "/career-list",
        icon: "application",
        name: "Career",
        parent: 29,
      },
      {
        id: 900,
        name: "Analytics",
        icon: "settings",
        parent: "",
        child: true,
      },
      {
        id: 901,
        path: "/login-analytics",
        icon: "analytics",
        name: "Login Analytics",
        parent: 900,
      },
      {
        id: 902,
        path: "/login-logs",
        icon: "database",
        name: "Login Logs",
        parent: 900,
      },
    ],
  },
  intMdAdminMenu: {
    title: "ADMIN",
    menus: [
      {
        id: 0,
        name: "Dashboard",
        icon: "structure",
        parent: "",
        path: "/admin-dashboard",
      },

      {
        id: 2,
        name: "Area Management",
        icon: "areamanage",
        parent: "",
        path: "",
        child: true,
      },
      {
        id: 80,
        name: "Area In KSPACE Premises",
        icon: "areamanage",
        parent: 2,
        path: "/builtup-space",
      },
      // {
      //   id: 81,
      //   name: "Equipped Facility",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/equip-facility",
      // },
      // {
      //   id: 82,
      //   name: "Land On Lease",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/land-lease",
      // },
      // {
      //   id: 83,
      //   name: "Joint Venture",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/joint-venture",
      // },
      // {
      //   id: 84,
      //   name: "Own Land",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/own-land",
      // },
      {
        id: 3,
        name: "Homepage Management",
        parent: "",
        child: true,
        icon: "house",
      },
      {
        id: 4,
        icon: "slide",
        path: "/banner-list",
        name: "Banner Images",
        parent: 3,
      },

      {
        id: 5,
        path: "/scrolling-list",
        icon: "bell",
        name: "Scrolling Notification",
        parent: 3,
      },
      {
        id: 6,
        path: "/scope-activity-list",
        icon: "activity",
        name: "Scope of Activities",
        parent: 3,
      },

      {
        id: 8,
        path: "/quotes-list",
        icon: "quote",
        name: "Messages ",
        parent: 3,
      },
      {
        id: 9,
        path: "/accomplishment-list",
        icon: "flag",
        name: "Our Accomplishments",
        parent: 3,
      },
      {
        id: 10,
        path: "/advertisement-list",
        icon: "flag",
        name: "Advertisements",
        parent: 3,
      },

      {
        id: 7,
        name: "About KSPACE",
        parent: 3,
        icon: "about",
        child: true,
      },
      {
        id: 51,
        path: "/maintext-list",
        icon: "maintext",
        name: "Main-Text",
        parent: 7,
      },
      {
        id: 52,
        path: "/organization-list",
        icon: "structure",
        name: "Organizational Structure",
        parent: 7,
      },
      {
        id: 10,
        path: "/domain-list",
        icon: "domain",
        name: "Domains",
        parent: "",
      },
      {
        id: 10,
        path: "/qualifications-list",
        icon: "domain",
        name: "Qualifications",
        parent: "",
      },
      {
        id: 11,
        name: "Companies",
        parent: "",
        icon: "company",
        child: true,
      },
      // {
      //   id: 13,
      //   path: "/newrequest-application-kspace",
      //   icon: "application",
      //   name: "New Applications",
      //   parent: 12,
      // },
      // {
      //   id: 14,
      //   path: "/companies-in-kspace",
      //   icon: "intitutions",
      //   name: "Institutions",
      //   parent: 12,
      // },
      {
        id: 21,
        name: "KSPACE",
        icon: "companylist",
        path: "/company-request-list/kspace",
        parent: 11,
        // child: true,
      },
      {
        id: 21,
        name: "KSPACE - Own Premises",
        icon: "companylist",
        path: "/company-request-list/own",
        parent: 11,
        // child: true,
      },

      {
        id: 21,
        name: "International",
        icon: "companylist",
        parent: 11,
        child: true,
      },
      {
        id: 18,
        name: "India",
        icon: "companylist",
        parent: 11,
        child: true,
      },

      {
        id: 22,
        path: "/international-companies-list",
        icon: "intitutions",
        name: "Institutions",
        parent: 21,
      },
      {
        id: 20,
        path: "/india-companies-list",
        icon: "intitutions",
        name: "Institutions",
        parent: 18,
      },

      {
        id: 29,
        name: "Market Research",
        icon: "market",
        parent: "",
        child: true,
      },
      {
        id: 30,
        path: "/tender-list",
        icon: "application",
        name: "Tender",
        parent: 29,
      },
      {
        id: 40,
        path: "/trade-list",
        icon: "application",
        name: "Trade Enquiries",
        parent: 29,
      },

      {
        id: 31,
        path: "/publication-list",
        icon: "activity",
        name: "Publications",
        parent: 29,
      },

      // {
      //   id: 35,
      //   path: "/professionalbodies-list",
      //   name: "Professional Bodies",
      //   icon: "house",
      //   parent: "",
      // },

      {
        id: 46,
        name: "Events",
        icon: "events",
        parent: "",
        child: true,
      },
      {
        id: 47,
        icon: "eventlist",
        name: "Kspace Event List",
        path: "/event-list-kspace",
        parent: 46,
      },
      {
        id: 47,
        icon: "eventlist",
        name: "Other Event List",
        path: "/event-list-others",
        parent: 46,
      },
      {
        id: 48,
        icon: "book",
        name: "Registration",
        path: "/event-booking",
        parent: 46,
      },
      //       {
      //   id: 58,
      //   icon: "book",
      //   name: "Payment Details",
      //   path: "/payment-details",
      //   parent: 46,
      // },

      {
        id: 49,
        icon: "slide",
        name: "Gallery",
        path: "",
        child: true,
        parent: "",
      },
      {
        id: 61,
        icon: "slide",
        name: "Images",
        path: "/images",
        parent: 49,
      },
      {
        id: 62,
        icon: "slide",
        name: "Videos",
        path: "/videos",
        parent: 49,
      },
      {
        id: 66,
        icon: "advisors",
        path: "/vendors-list",
        name: "Vendors",
        parent: "",
      },
      {
        id: 900,
        name: "Analytics",
        icon: "settings",
        parent: "",
        child: true,
      },
      {
        id: 901,
        path: "/login-analytics",
        icon: "analytics",
        name: "Login Analytics",
        parent: 900,
      },
      {
        id: 902,
        path: "/login-logs",
        icon: "database",
        name: "Login Logs",
        parent: 900,
      },
    ],
  },
  superAdminMenu: {
    title: "ADMIN",
    menus: [
      {
        id: 0,
        name: "Dashboard",
        icon: "structure",
        parent: "",
        path: "/admin-dashboard",
      },
      // {
      //   id: 1,
      //   name: "New Company Request",
      //   path: "/company-request-list",
      //   icon: "newcompany",
      //   parent: "",
      // },
      {
        id: 2,
        name: "Area Management",
        icon: "areamanage",
        parent: "",
        path: "",
        child: true,
      },
      {
        id: 83,
        name: "Built-Up Space Category",
        icon: "areamanage",
        parent: 2,
        path: "/area-types",
      },
      {
        id: 84,
        name: "Building & Floor Details",
        icon: "areamanage",
        parent: 2,
        path: "/rent-area",
      },
      {
        id: 85,
        name: "Built-Up Space Allocation Details",
        icon: "areamanage",
        parent: 2,
        path: "/space-allocation-details",
      },
      {
        id: 86,
        name: "Land Allocation Details",
        icon: "areamanage",
        parent: 2,
        path: "/land-allocation-details",
      },
      {
        id: 80,
        name: "Built-Up Space/Land in KSPACE Premises",
        icon: "areamanage",
        parent: 2,
        path: "/builtup-space",
      },
      // {
      //   id: 81,
      //   name: "Equipped Facility",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/equip-facility",
      // },
      // {
      //   id: 82,
      //   name: "Land On Lease",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/land-lease",
      // },
      // {
      //   id: 83,
      //   name: "Joint Venture",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/joint-venture",
      // },
      // {
      //   id: 84,
      //   name: "Own Land",
      //   icon: "areamanage",
      //   parent: 2,
      //   path: "/own-land",
      // },

      {
        id: 3,
        name: "Homepage Management",
        parent: "",
        child: true,
        icon: "house",
      },
      {
        id: 4,
        icon: "slide",
        path: "/banner-list",
        name: "Banner Images",
        parent: 3,
      },
      {
        id: 5,
        path: "/scrolling-list",
        icon: "bell",
        name: "Scrolling Notification",
        parent: 3,
      },
      {
        id: 6,
        path: "/scope-activity-list",
        icon: "activity",
        name: "Scope of Activities",
        parent: 3,
      },
      {
        id: 51,
        path: "/maintext-list",
        icon: "maintext",
        name: "Main-Text",
        parent: 7,
      },
      {
        id: 52,
        path: "/organization-list",
        icon: "structure",
        name: "Organizational Structure",
        parent: 7,
      },
      {
        id: 8,
        path: "/quotes-list",
        icon: "quote",
        name: "Messages",
        parent: 3,
      },
      {
        id: 9,
        path: "/accomplishment-list",
        icon: "flag",
        name: "Our Accomplishments",
        parent: 3,
      },
      {
        id: 10,
        path: "/advertisement-list",
        icon: "flag",
        name: "Advertisements",
        parent: 3,
      },

      {
        id: 7,
        name: "About KSPACE",
        parent: 3,
        icon: "about",
        child: true,
      },
      {
        id: 10,
        name: "Master Table",
        parent: "",
        icon: "book",
        child: true,
      },
      {
        id: 101,
        path: "/domain-list",
        icon: "technology",
        name: "Domains",
        parent: 10,
      },
      {
        id: 102,
        path: "/qualifications-list",
        icon: "academic",
        name: "Qualifications",
        parent: 10,
      },
      {
        id: 103,
        path: "/tenderCategory-list",
        icon: "companylist",
        name: "Tender - Category",
        parent: 10,
      },
      {
        id: 104,
        path: "/tenderOrganization-list",
        icon: "company",
        name: "Tender - Organizations",
        parent: 10,
      },
      {
        id: 105,
        path: "/techo-transfer-category-list",
        icon: "companylist",
        name: "Technology - Category",
        parent: 10,
      },
      {
        id: 106,
        path: "/techo-transfer-organization-list",
        icon: "company",
        name: "Technology - Organizations",
        parent: 10,
      },
      {
        id: 11,
        name: "Companies",
        parent: "",
        icon: "company",
        child: true,
      },
      // {
      //   id: 13,
      //   path: "/newrequest-application-kspace",
      //   icon: "application",
      //   name: "New Applications",
      //   parent: 12,
      // },
      // {
      //   id: 21,
      //   name: "KSPACE",
      //   icon: "companylist",
      //   path: "/company-request-list",
      //   parent: 11,
      //   // child: true,
      // },
      {
        id: 21,
        name: "KSPACE premises",
        icon: "companylist",
        path: "/company-request-list/kspace",
        parent: 11,
        // child: true,
      },
      {
        id: 21,
        name: "KSPACE - Own Premises",
        icon: "companylist",
        path: "/company-request-list/own",
        parent: 11,
        // child: true,
      },
      // {
      //   id: 14,
      //   path: "/companies-in-kspace",
      //   icon: "intitutions",
      //   name: "Institutions",
      //   parent: 12,
      // },
      // {
      //   id: 1,
      //   name: "KSPACE",
      //   path: "/company-request-list",
      //   icon: "newcompany",
      //   parent: 11,
      // },
      {
        id: 15,
        name: "Existing companies affiliated with KSPACE",
        icon: "companylist",
        path: "/kerala-companies-list",
        parent: 11,
        // child: true,
      },
      // {
      //   id: 12,
      //   name: "KSPACE",
      //   icon: "companylist",
      //   parent: 11,
      //   child: true,
      // },

      // {
      //   id: 17,
      //   path: "/kerala-companies-list",
      //   icon: "intitutions",
      //   name: "Institutions",
      //   parent: 15,
      // },
      {
        id: 21,
        name: "International Companies",
        path: "/international-companies-list",
        icon: "companylist",
        parent: 11,
        // child: true,
      },
      {
        id: 18,
        name: "Indian Companies",
        path: "/india-companies-list",
        icon: "companylist",
        parent: 11,
        // child: true,
      },

      // {
      //   id: 22,
      //   path: "/international-companies-list",
      //   icon: "intitutions",
      //   name: "Institutions",
      //   parent: 21,
      // },
      // {
      //   id: 20,
      //   path: "/india-companies-list",
      //   icon: "intitutions",
      //   name: "Institutions",
      //   parent: 18,
      // },
      {
        id: 23,
        path: "/resource-list",
        name: "Resource Personnel",
        icon: "resource",
        parent: "",
      },

      {
        id: 26,
        path: "/manpower-list",
        name: "Expert Manpower Registry",
        parent: "",
        icon: "expert",
      },

      {
        id: 27,
        // path: "/candidates-list",
        name: "Job Seeker",
        parent: "",
        child: true,
        icon: "directory",
      },
      {
        id: 271,
        path: "/candidates-list/registry",
        name: "Job Seeker Registry",
        parent: 27,
        icon: "directory",
      },
      {
        id: 272,
        path: "/candidates-list/employed",
        name: "Directory of Job Seekers Employed through KSPACE",
        parent: 27,
        icon: "directory",
      },
      {
        id: 273,
        path: "/candidates-list/inactive",
        name: "Directory of Inactive Job Seeker Registrations",
        parent: 27,
        icon: "directory",
      },
      {
        id: 274,
        path: "/candidates-list/optedout",
        name: "Directory of Job Seekers Opted-Out",
        parent: 27,
        icon: "directory",
      },
      {
        id: 28,
        path: "/profiles-list",
        name: "Downloaded Profiles",
        parent: "",
        icon: "resource",
      },
      {
        id: 64,
        path: "/policies-list",
        name: "Policies & Regulations",
        parent: "",
        icon: "application",
      },
      {
        id: 65,
        path: "/incentives-list",
        name: "Financial Support and Incentives",
        parent: "",
        icon: "resource",
      },
      {
        id: 66,
        path: "/news-list",
        name: "News and Updates",
        parent: "",
        icon: "application",
      },
      {
        id: 67,
        path: "/market-analysis",
        name: "Market Analysis",
        parent: "",
        icon: "market",
      },
      {
        id: 68,
        path: "/challenges",
        name: "Challenges",
        parent: "",
        icon: "ideas",
      },
      {
        id: 29,
        name: "Market Research",
        icon: "market",
        parent: "",
        child: true,
      },
      {
        id: 30,
        path: "/tender-list",
        icon: "application",
        name: "Tender",
        parent: 29,
      },
      {
        id: 40,
        path: "/trade-list",
        icon: "application",
        name: "Trade Enquiries",
        parent: 29,
      },

      {
        id: 31,
        path: "/publication-list",
        icon: "activity",
        name: "Publications",
        parent: 29,
      },
      {
        id: 32,
        name: "New Business Ideas",
        icon: "ideas",
        parent: "",
        child: true,
      },
      {
        id: 33,
        path: "/project-proposal-list",
        icon: "proposals",
        name: "Project Proposals",
        parent: 32,
      },
      {
        id: 34,
        path: "/transfer-proposal-list",
        icon: "technology",
        name: "Technology Transfer Proposals",
        parent: 32,
      },
      // {
      //   id: 35,
      //   path: "/professionalbodies-list",
      //   name: "Professional Bodies",
      //   icon: "house",
      //   parent: "",
      // },

      {
        id: 38,
        name: "Academic Institutions",
        icon: "academic",
        parent: "",
        child: true,
      },
      {
        id: 39,
        path: "/academicinstitution-list",
        icon: "application",
        name: "Applications",
        parent: 38,
      },

      // {
      //   id: 42,
      //   path: "/institutionproposal-list",
      //   icon: "directory",
      //   name: "Student Proposal",
      //   parent: 38,
      // },

      // {
      //   id: 44,
      //   path: "/intershiptraining-list",
      //   icon: "directory",
      //   name: "Internship/Training",
      //   parent: 38,
      // },

      {
        id: 45,
        icon: "advisors",
        path: "/advisors-list",
        name: "Spacepark Advisors",
        parent: "",
      },
      {
        id: 87,
        name: "Internship",
        icon: "company",
        parent: "",
        child: true,
      },
      {
        id: 88,
        path: "/admin-internship-requests",
        icon: "news",
        name: "Requests",
        parent: 87,
      },
      {
        id: 89,
        path: "/admin-internship-applications",
        icon: "application",
        name: "Applications",
        parent: 87,
      },
      {
        id: 91,
        path: "/admin-internships-doing",
        icon: "activity",
        name: "Directory of Internships Doing",
        parent: 87,
      },
      {
        id: 92,
        path: "/admin-internships-completed",
        icon: "book",
        name: "Directory of Internships Completed",
        parent: 87,
      },
      {
        id: 93,
        path: "/admin-internships-absorbed",
        icon: "resource",
        name: "Directory of Internships Absorbed",
        parent: 87,
      },

      {
        id: 46,
        name: "Events",
        icon: "events",
        parent: "",
        child: true,
      },
      {
        id: 49,
        icon: "slide",
        name: "Gallery",
        path: "",
        child: true,
        parent: "",
      },
      {
        id: 64,
        icon: "advisors",
        path: "/admin-mou",
        name: "MOU",
        parent: "",
      },

      {
        id: 65,
        icon: "advisors",
        path: "/membership",
        name: "Memberships",
        parent: "",
      },

      {
        id: 65,
        icon: "advisors",
        path: "/faq-list",
        name: "FAQ",
        parent: "",
      },

      {
        id: 47,
        icon: "eventlist",
        name: "Kspace Event List",
        path: "/event-list-kspace",
        parent: 46,
      },
      {
        id: 47,
        icon: "eventlist",
        name: "Other Event List",
        path: "/event-list-others",
        parent: 46,
      },
      {
        id: 48,
        icon: "book",
        name: "Registration",
        path: "/event-booking",
        parent: 46,
      },
      // {
      //   id: 49,
      //   icon: "slide",
      //   name: "Gallery",
      //   path: "",
      //   child: true,
      //   parent: "",
      // },
      // {
      //   id: 64,
      //   icon: "advisors",
      //   path: "/admin-mou",
      //   name: "MOU",
      //   parent: "",
      // },
      // {
      //   id: 65,
      //   icon: "advisors",
      //   path: "/membership",
      //   name: "Memberships",
      //   parent: "",
      // },
      // {
      //   id: 70,
      //   icon: "advisors",
      //   path: "/faq-list",
      //   name: "FAQ",
      //   parent: "",
      // },
      {
        id: 66,
        icon: "advisors",
        path: "/vendors-list",
        name: "Vendors",
        parent: "",
      },
      {
        id: 90,
        icon: "mail",
        path: "/bulk-emails",
        name: "Bulk Email",
        parent: "",
      },

      {
        id: 61,
        icon: "slide",
        name: "Images",
        path: "/images",
        parent: 49,
      },
      {
        id: 62,
        icon: "slide",
        name: "Videos",
        path: "/videos",
        parent: 49,
      },
      {
        id: 900,
        name: "Settings",
        icon: "settings",
        parent: "",
        child: true,
      },
      {
        id: 901,
        path: "/login-analytics",
        icon: "analytics",
        name: "Login Analytics",
        parent: 900,
      },
      {
        id: 902,
        path: "/login-logs",
        icon: "database",
        name: "Login Logs",
        parent: 900,
      },
    ],
  },
};
